var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBug = function SvgBug(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 89,
    viewBox: "0 0 80 89",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.76 10.552c3.34 2.332 5.56 6.456 5.56 11.156 0 7.272-5.32 13.172-11.88 13.172-6.56 0-11.88-5.9-11.88-13.172 0-4.64 2.164-8.72 5.432-11.068",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.888 2.4v-.564c0-.434-.172-.85-.48-1.157C41.103.372 40.687.2 40.253.2h-3.628c-.904 0-1.636.732-1.636 1.636V2.4c-2.512.88-4.236 2.72-4.236 4.852 0 3.008 3.44 5.452 7.688 5.452 4.248 0 7.688-2.444 7.688-5.452 0-2.132-1.728-3.972-4.24-4.852zM22.824 3.176l3.232 8.292c.122.318.35.585.644.756l2.3 1.148M20.22 21.336h5.58M28.48 29.076l-3.624 1.744c-.255.12-.455.334-.56.596L20.44 40.98M54.6 3.176l-3.232 8.292c-.123.317-.35.584-.644.756l-2.3 1.148M57.204 21.336h-5.58M48.944 29.076l3.624 1.744c.254.123.453.335.56.596l3.852 9.564",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.464 16.8h24.052c1.677 0 3.036 1.36 3.036 3.036V64c0 .805-.32 1.577-.89 2.147-.569.57-1.34.889-2.146.889H3.236c-.805 0-1.577-.32-2.147-.89C.52 65.578.2 64.807.2 64V19.832C.202 18.157 1.56 16.8 3.236 16.8H27.2M.2 56.76h76.24M58.024 67.364v2.428c0 2.226-1.798 4.033-4.024 4.044H22.888c-1.073.001-2.103-.425-2.862-1.183-.76-.759-1.186-1.788-1.186-2.861v-2.54M30.452 73.876v1.896s-.112 4.352-4.428 4.204h-3.832c-1.546 0-2.8 1.254-2.8 2.8v2.8h22.104M46.08 73.876v1.896s.112 4.352 4.428 4.204h3.832c1.546 0 2.8 1.254 2.8 2.8v2.8h-8.196",
    transform: "translate(2 2)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bug.063a6295.svg";
export { ForwardRef as ReactComponent };